
import ticker from '../../utils/ticker';

export default class PlaneIllustration {
	constructor() {

		this.el = {
			section: document.querySelector('[data-airplane-illustration]'),
			frames: document.querySelector('[data-airplane-illustration] .frames'),
			canvas: document.querySelector('[data-airplane-illustration] canvas')
		};

		if (!this.el.section) {
			return;
		}

		this.ctx = this.el.canvas.getContext('2d');
		this.ctx.scale(window.devicePixelRatio || 1, window.devicePixelRatio || 1);

		this.frameCount = 47;
		this.imagesLoaded = 0;
		this.images = [ this.el.frames.querySelector('img') ];
		this.animate = false;
		this.index = 0;

		this.onFrame = this.onFrame.bind(this);
		this.ticker = new ticker(24, this.onFrame);

		this._resize = this._resize.bind(this);
		window.addEventListener('resize', this._resize);
		this._resize();

		this._preloadImages();
	}

	_resize() {

		this.canvasWidth            = this.el.frames.clientWidth;
		this.canvasHeight           = this.el.frames.clientHeight;

		this.el.canvas.width        = this.canvasWidth * window.devicePixelRatio;
		this.el.canvas.height       = this.canvasHeight * window.devicePixelRatio;

		this.el.canvas.style.width  = this.canvasWidth + 'px';
		this.el.canvas.style.height = this.canvasHeight + 'px';
	}

	_preloadImages() {

		for (let i = 0; i <= this.frameCount; i++) {

			let img = new Image();
			this.images[i] = img;

			img.onload = () => {
				if (this.imagesLoaded++ == this.frameCount) {
					this.animate = true;
				}
			}

			img.src = `/assets/images/illustrations/airplane/frames/frame-${i}.png`;
		}
	}

	onFrame(fps, elapsed) {

		if (!this.animate) {
			return;
		}

		this.index = (this.index + 1) % this.frameCount;

		this.ctx.clearRect(0, 0, this.canvasWidth * window.devicePixelRatio || 1, this.canvasHeight * window.devicePixelRatio || 1);
		this.ctx.drawImage(this.images[this.index], 0, 0, this.canvasWidth * window.devicePixelRatio || 1, this.canvasHeight * window.devicePixelRatio || 1);
	}
}
